var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import ButtonComponent from "../../comments/button";
import { useDispatch } from 'react-redux';
import { validationAction } from "../../reducers/layer";
import WrapComponent from "../../comments/wrap";
var SingleLayer = function (_a) {
    var name = _a.name, _b = _a.message, message = _b === void 0 ? '' : _b, _c = _a.btnTxt, btnTxt = _c === void 0 ? '확인' : _c;
    var dispatch = useDispatch();
    var onCloseHandler = function () {
        dispatch(validationAction({
            name: null,
            data: null
        }));
    };
    var msgLength = (message === null || message === void 0 ? void 0 : message.length) || 0;
    return (React.createElement(WrapComponent, null,
        React.createElement(React.Fragment, null,
            React.createElement(ButtonComponent, { type: 'close', onClick: onCloseHandler }),
            React.createElement(ContentBox, { msgLength: msgLength },
                React.createElement("p", null,
                    React.createElement("b", null, message))),
            name === 'validation' ?
                React.createElement(ButtonComponent, { type: 'isOk', onClick: onCloseHandler }, btnTxt)
                :
                    '')));
};
export default SingleLayer;
var ContentBox = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size:17px;\n    height:", "px;\n    margin:0 0 21px;\n    overflow:auto;\n    word-break: break-all;\n"], ["\n    font-size:17px;\n    height:", "px;\n    margin:0 0 21px;\n    overflow:auto;\n    word-break: break-all;\n"])), function (props) { return props.msgLength > 35 ? 42 : 28; });
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/layer/single_layer.tsx
// module id = 306
// module chunks = 0